import { useState } from 'react';
import { Card as RBCard } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Icon from './Icon';
import { Col, Row } from './Grid';

/**
 * General purpose Bootstrap Card component.
 * 
 * The components supports collapsibility and abstracts the markup for titles.
 * @component
 */
const Card = ({ title, children, defaultCollapsed = false, fixed = false, cardStyle, headerStyle, bodyStyle, headerControls, footerControls, footerSyle }) => {
    const [collapsed, setCollapsed] = useState(!!defaultCollapsed);

    return <RBCard className='mx-1 my-3' style={cardStyle}>
        { title ? <RBCard.Header style={{ cursor: fixed ? null : 'pointer', fontWeight: 'bold', fontSize: 'larger', ...headerStyle }} onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (!fixed) {
                setCollapsed(!collapsed);
            }
        }}>
            <Row>
                {fixed ? null : <Col xs='auto' className="mx-2 d-flex align-items-center"><Icon intent={collapsed ? 'expand' : 'collapse'}></Icon></Col>} 
                <Col className="d-flex align-items-center">{title}</Col>
                {headerControls && <Col xs='auto' className="text-end d-flex align-items-center" onClick={e => e.stopPropagation()}>
                    {headerControls}
                </Col>}
            </Row>
        </RBCard.Header> : null}
        { collapsed ? null : <RBCard.Body style={bodyStyle}>
            {children}
        </RBCard.Body> }
        {footerControls ? <RBCard.Footer style={{backgroundColor: 'inherit', ...footerSyle,} }>{footerControls}</RBCard.Footer> : null}
    </RBCard>
}

Card.propTypes = {
    /**
     * Components that make up the title of the card, if not supplied no header will be rendered
     */
    title: PropTypes.node,
    /**
     * Components that make up the body of the card
     */
    children: PropTypes.node.isRequired,
    /**
     * The initial collapse state of the card
     */
    defaultCollapsed: PropTypes.bool,
    /**
     * Option to disable the card capability to be collapsed
     */
    fixed: PropTypes.bool,
    /**
     * A React Node which are the controls to render in the card header
     */
    headerControls: PropTypes.node,
    /**
     * A React Node which are the controls to render in the card footer
     */
    footerControls: PropTypes.node,
    /**
     * A style object to be applied to the card footer
     */
    footerStyle: PropTypes.object,
    /**
     * A style object to be applied to the card header
     */
    headerStyle: PropTypes.object,
    /**
     * A style object to be applied to the card body
     */
    bodyStyle: PropTypes.object,
    /**
     * A style object to be applied to the entire card
     */
    cardStyle: PropTypes.object,
}

export default Card;